import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Button3D from '~/components/shared/Button3D';
import { MuiRemixLink } from '~/components/shared/links';
import HomeBox from '~/images/home_hero_box.svg';
import HomePlus from '~/images/home_hero_elements_plus.svg';
import HomePen from '~/images/home_hero_pen.svg';
import { baseImgUrl } from '~/utils/constants';

export default function Intro() {
  return (
    <Box sx={{ background: 'linear-gradient(0deg, #FFFFFF 0%, #85B1D5 100%)', pt: 9 }}>
      <Container>
        <Stack mt={6} mb={8} flexDirection={{ xs: 'column', md: 'row' }}>
          <Stack
            width={{ xs: '100%', md: '25%' }}
            pr={3}
            justifyContent="center"
            alignItems="center"
            display={{ xs: 'none', md: 'flex' }}
          >
            <img
              src={`${baseImgUrl}swagcharm-boxes-home.png`}
              srcSet={`${baseImgUrl}swagcharm-boxes-home.png, ${baseImgUrl}swagcharm-boxes-home-2x.png 2x, ${baseImgUrl}swagcharm-boxes-home-3x.png 3x`}
              alt="hero home"
              width={243}
              height={428}
              style={{
                width: '100%',
                height: 'auto',
                minWidth: '100%',
                minHeight: '100%',
                transform: 'scale(0.9) translate(-80px,-130px)',
              }}
            />
          </Stack>

          <Stack width={{ xs: '100%', md: '50%' }} alignItems="center" textAlign="center">
            <Typography component="h1" variant="h2" mb={3} fontSize={{ xs: '2.5rem', sm: '3.75rem' }} fontWeight={800}>
              Charm The World With Custom Swag That Excites
            </Typography>

            <Typography variant="subtitle1" letterSpacing="0.15px" mb={3}>
              Your brand and image mean something.
              <br />
              <strong>SwagCharm</strong> is your source for{' '}
              <strong>custom Swag to elevate your company, school, fundraising event, organization, and more!</strong>
              <br />
              Choose <strong>quality Swag</strong> that embodies your passion and purpose.
            </Typography>

            <Stack display={{ xs: 'flex', md: 'none' }} mb={3}>
              <img
                src={`${baseImgUrl}swagcharm-blue-box.png`}
                srcSet={`${baseImgUrl}swagcharm-blue-box.png, ${baseImgUrl}swagcharm-blue-box-2x.png 2x, ${baseImgUrl}swagcharm-blue-box-3x.png 3x`}
                alt="hero home"
                width={300}
                height={300}
                style={{
                  width: '100%',
                  height: 'auto',
                  minWidth: '100%',
                  minHeight: '100%',
                }}
              />
            </Stack>

            <Grid container spacing={3} mb={5}>
              <Grid item xs={12} sm={4}>
                <Stack alignItems="center">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    bgcolor="rgba(255, 255, 255, 0.45)"
                    borderRadius="50%"
                    width="48px"
                    height="48px"
                    p={1.5}
                    mb={2.5}
                  >
                    <img src={HomePen} alt="Home pen" width="24px" height="24px" />
                  </Box>
                  <Typography variant="subtitle1" maxWidth={210}>
                    Free <strong>brand, team, and personal Swag designs</strong>
                  </Typography>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Stack alignItems="center">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    bgcolor="rgba(255, 255, 255, 0.45)"
                    borderRadius="50%"
                    width="48px"
                    height="48px"
                    p={1.5}
                    mb={2.5}
                  >
                    <img src={HomePlus} alt="Home elements plus" width="24px" height="24px" />
                  </Box>
                  <Typography variant="subtitle1" maxWidth={210}>
                    A free <strong>Swag Management Platform and Dashboard</strong>
                  </Typography>
                </Stack>
              </Grid>

              <Grid item xs={12} sm={4}>
                <Stack alignItems="center">
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    bgcolor="rgba(255, 255, 255, 0.45)"
                    borderRadius="50%"
                    width="48px"
                    height="48px"
                    p={1.5}
                    mb={2.5}
                  >
                    <img src={HomeBox} alt="Home Box" width="24px" height="24px" />
                  </Box>
                  <Typography variant="subtitle1" maxWidth={210}>
                    Easy <strong>worldwide delivery with Multishipping</strong>
                  </Typography>
                </Stack>
              </Grid>
            </Grid>

            <Button3D href="/shop">Shop Swag Now</Button3D>
          </Stack>

          <Stack width={{ xs: '100%', md: '25%' }} pl={3} display={{ xs: 'none', md: 'flex' }}>
            <img
              src={`${baseImgUrl}swagcharm-blue-box.png`}
              srcSet={`${baseImgUrl}swagcharm-blue-box.png, ${baseImgUrl}swagcharm-blue-box-2x.png 2x, ${baseImgUrl}swagcharm-blue-box-3x.png 3x`}
              alt="hero home"
              width={300}
              height={300}
              style={{
                width: '100%',
                height: 'auto',
                minWidth: '100%',
                minHeight: '100%',
                transform: 'scale(1.1) translate(60px,-80px)',
              }}
            />
          </Stack>
        </Stack>

        <Stack
          direction={{ xs: 'column', lg: 'row' }}
          gap={3}
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
        >
          <MuiRemixLink href="/shop/swag-packs" underline="none" aria-label="Swag Packs" color="text.primary">
            <Stack
              p={3}
              justifyContent="center"
              alignItems="center"
              border="1px solid #302F54"
              boxShadow="6px 8px 0px #302F54"
              borderRadius="16px"
              bgcolor="#FFF"
              minHeight="100%"
              sx={{
                '&:hover': { borderColor: '#009DC8', boxShadow: '6px 8px 0px #009DC8', cursor: 'pointer' },
                '&:active': { boxShadow: '1px 2px 0px #302F54', cursor: 'pointer' },
              }}
              maxWidth={350}
            >
              <Stack justifyContent="center" alignItems="center">
                <Typography variant="h5" mb={1} textAlign="center">
                  Buy Swag Packs
                </Typography>
                <Typography variant="body1" mb={3} textAlign="center">
                  Select our most popular packs and customize them with your branding.
                </Typography>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="50%"
                  bgcolor="rgba(25, 118, 210, 0.04)"
                  width={140}
                  height={140}
                  p="20px"
                  mb={3}
                >
                  <img
                    src={`${baseImgUrl}prebuilt_pack.png`}
                    srcSet={`${baseImgUrl}prebuilt_pack.png, ${baseImgUrl}prebuilt_pack-2x.png 2x, ${baseImgUrl}prebuilt_pack-3x.png 3x`}
                    alt="Pre-build Pack"
                    width={100}
                    height={100}
                    style={{
                      width: '100%',
                      height: 'auto',
                      minWidth: '100%',
                      minHeight: '100%',
                      transform: 'scale(1.4)',
                    }}
                  />
                </Stack>
                <Typography variant="subtitle2" fontSize="13px" color="primary.main" textAlign="center">
                  GET STARTED
                </Typography>
              </Stack>
            </Stack>
          </MuiRemixLink>

          <MuiRemixLink
            href="/guided-pack-builder"
            underline="none"
            aria-label="Create Custom Pack"
            color="text.primary"
          >
            <Stack
              p={3}
              justifyContent="center"
              alignItems="center"
              border="1px solid #302F54"
              boxShadow="6px 8px 0px #302F54"
              borderRadius="16px"
              bgcolor="#FFF"
              minHeight="100%"
              sx={{
                '&:hover': { borderColor: '#009DC8', boxShadow: '6px 8px 0px #009DC8', cursor: 'pointer' },
                '&:active': { boxShadow: '1px 2px 0px #302F54', cursor: 'pointer' },
              }}
              maxWidth={350}
            >
              <Stack justifyContent="center" alignItems="center">
                <Typography variant="h5" mb={1} textAlign="center">
                  Pack Builder
                </Typography>
                <Typography variant="body1" mb={3} textAlign="center">
                  Customize a range of products from scratch or pick a template.
                </Typography>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="50%"
                  bgcolor="rgba(25, 118, 210, 0.04)"
                  width={140}
                  height={140}
                  p="20px"
                  mb={3}
                >
                  <img
                    src={`${baseImgUrl}Createyourpack.png`}
                    srcSet={`${baseImgUrl}Createyourpack.png, ${baseImgUrl}Createyourpack-2x.png 2x, ${baseImgUrl}Createyourpack-3x.png 3x`}
                    alt="Create Your Pack Icon"
                    width={100}
                    height={100}
                    style={{
                      width: '100%',
                      height: 'auto',
                      minWidth: '100%',
                      minHeight: '100%',
                      transform: 'scale(1.1)',
                    }}
                  />
                </Stack>
                <Typography variant="subtitle2" fontSize="13px" color="primary.main" textAlign="center">
                  GET STARTED
                </Typography>
              </Stack>
            </Stack>
          </MuiRemixLink>

          <MuiRemixLink href="/shop/bulk-swag" underline="none" aria-label="Bulk Swag" color="text.primary">
            <Stack
              p={3}
              justifyContent="center"
              alignItems="center"
              border="1px solid #302F54"
              boxShadow="6px 8px 0px #302F54"
              borderRadius="16px"
              bgcolor="#FFF"
              minHeight="100%"
              sx={{
                '&:hover': { borderColor: '#009DC8', boxShadow: '6px 8px 0px #009DC8', cursor: 'pointer' },
                '&:active': { boxShadow: '1px 2px 0px #302F54', cursor: 'pointer' },
              }}
              maxWidth={350}
            >
              <Stack justifyContent="center" alignItems="center">
                <Typography variant="h5" mb={1} textAlign="center">
                  Buy Swag in Bulk
                </Typography>
                <Typography variant="body1" mb={3} textAlign="center">
                  Select our amazing bulk products and customize them with your branding.
                </Typography>
                <Stack
                  justifyContent="center"
                  alignItems="center"
                  borderRadius="50%"
                  bgcolor="rgba(25, 118, 210, 0.04)"
                  width={140}
                  height={140}
                  p="20px"
                  mb={3}
                >
                  <img
                    src={`${baseImgUrl}Bulkswag.png`}
                    srcSet={`${baseImgUrl}Bulkswag.png, ${baseImgUrl}Bulkswag-2x.png 2x, ${baseImgUrl}Bulkswag-3x.png 3x`}
                    alt="Bulk Swag"
                    width={100}
                    height={100}
                    style={{
                      width: '100%',
                      height: 'auto',
                      minWidth: '100%',
                      minHeight: '100%',
                      transform: 'scale(1.4)',
                    }}
                  />
                </Stack>
                <Typography variant="subtitle2" fontSize="13px" color="primary.main" textAlign="center">
                  GET STARTED
                </Typography>
              </Stack>
            </Stack>
          </MuiRemixLink>
        </Stack>
      </Container>
    </Box>
  );
}
